import { render, staticRenderFns } from "./PersonTile.vue?vue&type=template&id=75be3f17&scoped=true&"
import script from "./PersonTile.vue?vue&type=script&lang=js&"
export * from "./PersonTile.vue?vue&type=script&lang=js&"
import style0 from "./PersonTile.vue?vue&type=style&index=0&id=75be3f17&lang=scss&scoped=true&"
import style1 from "./PersonTile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be3f17",
  null
  
)

/* custom blocks */
import block0 from "./PersonTile.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports